angular.module('qkr').controller('outletBulkUploadController', function($uibModal, appConfig,
                                                                        $uibModalInstance, Upload) {

    this.saving = false;
    this.errors = null;
    this.errorMsg = null;
    this.f = null;

    const vm = this;
    this.reload = false;
    this.fileName = 'merchant_outlets.xlsx';

    this.init = function() {
    };

    this.ok = function() {
        if (this.reload) {
            $uibModalInstance.close();
        } else {
            $uibModal.open({
                template: require('../../../templates/common/modalBasicPopup.html'),
                controller: 'CommonModalPopupController',
                windowClass: 'fade basic-modal',
                backdrop: 'static',
                resolve: {
                    title() {
                        return 'Oops!';
                    },
                    message() {
                        return 'Please upload an Excel file to save any changes';
                    }
                }
            });
        }
    };

    this.cancel = function() {
        $uibModalInstance.dismiss();
    };

    const validate = function() {
        // Possible validation
        vm.errors = {};
        return true;
    };

    this.uploadFile = function(file) {
        vm.f = file;
        if (validate()) {
            var file = vm.f;
            vm.errorMsg = null;
            if (file && !file.$error) {
                console.info('asdfasdfa');
                file.upload = Upload.upload({
                    url: appConfig.apiUrl + 'outlet/bulkUpload',
                    file
                });
                file.upload.then((response) => {
                    vm.reload = true;
                    angular.element(document.querySelector('.outlet-upload-modal .btn-cancel')).remove();
                    angular.element(document.querySelector('.outlet-upload-modal .btn-success')).text('Ok');
                }, (reason) => {
                    if (reason.status !== 200) {
                        vm.errorMsg = reason.data.exception;
                    }
                });
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/controllers/merchant/outlet/outlet.bulk.upload.controller.js